import { useCallback } from 'react'

const useCancelButtonAction = () =>
  useCallback(() => {
    const hiddenCancelButton = document.getElementById('cancel') as HTMLButtonElement
    const params = new URLSearchParams(window.location.search)
    const redirectUri = params.get('redirect_uri')
    const responseMode = params.get('response_mode') ?? 'fragment'

    if (hiddenCancelButton) {
      hiddenCancelButton.click()
    } else if (redirectUri) {
      window.location.replace(
        `${redirectUri}${
          responseMode === 'fragment' ? '#' : '?'
        }error=access_denied&error_description=AADB2C90091%3a+The+user+has+cancelled+entering+self-asserted+information.`,
      )
    } else {
      window.history.back()
    }
  }, [])

export default useCancelButtonAction
